import "knockout";
import $ from "jquery";
import moment from "moment";
import metaCache from "flow/utils/metaCache";
import register from "flow/knockout/register";

register.registerKnockoutBinding("clock", {
    init: function (element) {
        const dateFormatString = metaCache.lookup("FlowHtml.Translations.DateTimeFormat", "lll");

        const updateTime = function () {
            $(element).text(moment().format(dateFormatString));
        };

        setInterval(updateTime, 10000);

        updateTime();
    }
});
